export const error = { color:'red' }
export const bordererror = { borderColor:'red' }


// WEBPACK FOOTER //
// ./src/modules/components/style.js